import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-university-dashboard',
  templateUrl: './university-dashboard.component.html',
  styleUrls: ['./university-dashboard.component.css']
})
export class UniversityDashboardComponent implements OnInit {

  constructor(private documentVerificationListService: DocumentVerificationListService,
    private dashboardService: DashboardService) { }
  overAllSummary;
  ageingSummary;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  yearList;
  currentYear;
  dtElement: DataTableDirective;
  ngOnInit(): void {

    this.dashboardService.getYear().pipe(first())
    .subscribe(
      data => {
        console.log("years--->",data)
        this.yearList = data.respData;
      }
    )

    console.log("----------------********8",(new Date()).getFullYear());
    this.currentYear = (new Date()).getFullYear();

    this.documentVerificationListService.getOverallSummary(this.currentYear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.overAllSummary = data.respData;
          // console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })

      this.documentVerificationListService.getAgeingSummary(this.currentYear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.ageingSummary = data.respData;
          // console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      destroy: true,
      order: [[1, 'desc']]
    };

  }

  ngAfterViewInIt() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  getDataByYear(event){
    console.log("----YEAR----->",event);
    var year = event.substring(3,7)
    console.log(year);
      this.documentVerificationListService.getOverallSummary(year)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.overAllSummary = data.respData;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
          });
          // console.log(this.request)
          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })

      this.documentVerificationListService.getAgeingSummary(year)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.ageingSummary = data.respData;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
          });
          // console.log(this.request)
          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
  }

}
